import { InstanceScreen } from 'component/navigation/instance';

export default function ArticleManageVideoVotingScreen() {
    return <InstanceScreen screenKey='manageVideoVoting' />;
}
